import { useMemo, useCallback } from 'react'

export type Fn<A extends any[] = any[], R = any> = (...args: A) => R

export function useWrapCallback<A extends Fn>(handle: A, deps: any[] = []) {
  const wrap = useCallback(
    function wrap<C extends Fn>(callback: C) {
      if (typeof callback === 'function') {
        return function exec(...args: Parameters<C>): ReturnType<C> {
          const results = callback(...args)
          handle(...args)
          return results
        }
      }

      return handle
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [handle, ...deps]
  )

  return useMemo(() => ({ exec: handle, wrap }), [handle, wrap])
}
